const ResponseCode = {
    SUCCESS:        0,
    ERROR_UNKNOWN: -1,
    ERROR_NETWORK: -2
};

export {ResponseCode};
